import React from 'react'
import { Link } from "react-router-dom"
import { Row, Col, Typography, Button, Space } from 'antd'
import Genetics_img from '../../images/genetics/Genetics.png'
import GWAS from '../../images/genetics/GWAS.svg'
import eQTL from '../../images/genetics/eQTL.svg'

import './genetics.css'

const { Title } = Typography

class Genetics extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col>
                        <img src={Genetics_img} className="genetics-bg" />
                        <div className="genetics-bg-desc">
                            <Title level={2}>Genetics</Title>
                            <Title level={5}>Collection of phenotypes and gene expression patterns within tomato association mapping panel, and related loci according to GWAS and linkage analysis.</Title>
                        </div>
                    </Col>
                </Row>
                <Row className="genetics-feature" justify="center">
                    <Col span={6}>
                        <Row justify="center" align="middle">
                            <Space>
                                <Col>
                                    <img src={GWAS} />
                                </Col>
                                <Col>
                                    <Title level={3}>GWAS</Title>
                                </Col>
                            </Space>
                        </Row>
                        <Row justify="center">
                            <Col span={24}>
                                <Link to="/search/gwas" className="search-a"><Button type="primary" size="large" className="search-btn">Search</Button></Link>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Link to="/tool/gwasviz" className="search-a"><Button type="primary" size="large" className="visual-btn">Visualizer</Button></Link>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={6}>
                        <Row justify="center" align="middle">
                            <Space>
                                <Col>
                                    <img src={eQTL} />
                                </Col>
                                <Col>
                                    <Title level={3}>eQTL</Title>
                                </Col>
                            </Space>
                        </Row>
                        <Row justify="center">
                            <Col span={24}>
                                <Link to="/search/egwas" className="search-a"><Button type="primary" size="large" className="search-btn">Search</Button></Link>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Link to="/tool/eqtlviz" className="search-a"><Button type="primary" size="large" className="jbrowse-btn">Visualizer</Button></Link>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default Genetics
